import { atom } from "jotai";

export const navbarSuppressionCountAtom = atom(0);
